export default {
    page: function() {
        this.loadSurveys()
    }
}
